/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { StandaloneJwVideoVideo as ResolvedStandaloneJwVideoVideo } from 'base/components/standalone/JwVideo/Video';

export const JwVideoVideo: typeof ResolvedStandaloneJwVideoVideo = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneJwVideoVideo {...props} />
    );
});

export type JwVideoVideoProps = PropsFromComponent<typeof JwVideoVideo>;

/** @deprecated Use slot architecture instead */
export const JwVideoVideoWith = (extras: DynamicStandaloneExtras): typeof JwVideoVideo => {
    return function JwVideoVideo(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'JwVideoVideo');
        return <ResolvedStandaloneJwVideoVideo {...mergeProps({ options: { theme } }, props)} />;
    }
}